const initBlock = async function( $block ) {
	function getChicagoTime() {
		const now = new Date();
		const options = {
			timeZone: 'America/Chicago',
			year: 'numeric',
			month: 'numeric',
			day: 'numeric',
			hour: 'numeric',
			minute: 'numeric',
			second: 'numeric',
			hour12: false
		};
		const parts = new Intl.DateTimeFormat( 'en-US', options ).formatToParts( now );
		const get = ( type ) => Number( parts.find( p => p.type === type )?.value );
		return {
			year: get( 'year' ),
			month: get( 'month' ),
			day: get( 'day' ),
			hour: get( 'hour' ),
			minute: get( 'minute' ),
			second: get( 'second' ),
			weekday: new Intl.DateTimeFormat( 'en-US', { timeZone: 'America/Chicago', weekday: 'short' } ).format( now )
		};
	}

	function shouldShowSection() {
		const t = getChicagoTime();
		const weekdayNum = new Date( `${t.year}-${t.month}-${t.day}` ).getDay();
		const hour = t.hour;

		if ( weekdayNum === 0 || weekdayNum === 6 ) {
			return true;
		}

		if ( hour >= 18 || hour < 6 ) {
			return true;
		}
		return false;
	}

	function updateSectionVisibility() {
		if ( shouldShowSection() ) {
			$block.show();
		} else {
			$block.hide();
		}
	}

	updateSectionVisibility();
	setInterval( updateSectionVisibility, 60 * 1000 );
};

app.loadBlock( initBlock, 'section-deep-lawn', '.section-deep-lawn' );

if ( module.hot ) {
	module.hot.accept();
}
